/* Encaminarnos · Carrito lateral y página del carrito (diseño del mockup sobre el carrito real de Shopify) */
const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const EK = window.ekCart || (window.ekCart = {});

if (!EK.ready) {
  EK.ready = true;
  const secs = () => $$('[data-ekc-sec]').map((e) => e.dataset.ekcSec);
  const drawer = () => $('[data-ekc-drawer]');
  const onCartPage = () => !!$('[data-ekc-page]');
  const lock = (on) => document.documentElement.classList.toggle('ek-dlock', on);

  EK.open = () => {
    if (onCartPage()) return;
    const d = drawer(); if (!d) { location.href = ROOT + 'cart'; return; }
    d.classList.add('on'); $('#cScrim')?.classList.add('on'); d.setAttribute('aria-hidden', 'false'); lock(true);
  };
  EK.close = () => {
    const d = drawer(); if (!d) return;
    d.classList.remove('on'); $('#cScrim')?.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); lock(false);
  };

  /* Vuelve a pintar las secciones del carrito con el carrito real */
  EK.refresh = async (html) => {
    const ids = secs(); if (!ids.length) return;
    try {
      const data = html || (await (await fetch(ROOT + '?sections=' + ids.join(','))).json());
      ids.forEach((id) => {
        if (!data[id]) return;
        const doc = new DOMParser().parseFromString(data[id], 'text/html');
        const fresh = doc.querySelector(`[data-ekc-sec="${id}"]`), cur = $(`[data-ekc-sec="${id}"]`);
        if (!fresh || !cur) return;
        const wasOpen = cur.querySelector('[data-ekc-drawer].on');
        const sc = cur.querySelector('[data-ekc-body]')?.scrollTop || 0;
        cur.innerHTML = fresh.innerHTML;
        if (wasOpen) { cur.querySelector('[data-ekc-drawer]')?.classList.add('on'); cur.querySelector('#cScrim')?.classList.add('on'); cur.querySelector('[data-ekc-drawer]')?.setAttribute('aria-hidden', 'false'); }
        const b = cur.querySelector('[data-ekc-body]'); if (b) b.scrollTop = sc;
      });
      const c = await (await fetch(ROOT + 'cart.js')).json();
      $$('#cartN').forEach((n) => { n.textContent = c.item_count; n.classList.remove('bump'); void n.offsetWidth; n.classList.add('bump'); });
    } catch (e) { console.warn('EK cart', e); }
  };

  const post = async (url, body) => {
    const r = await fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: secs().join(',') }) });
    const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'error');
    return j;
  };
  const busy = (on) => $$('[data-ekc-sec]').forEach((s) => s.style.opacity = on ? '.6' : '');

  async function act(e) {
    const b = e.target.closest('[data-a]'); if (!b || !b.closest('[data-ekc-sec]')) return;
    e.preventDefault(); busy(true);
    try {
      const a = b.dataset.a; let j;
      if (a === 'add') { await post('cart/add.js', { items: [{ id: +b.dataset.v, quantity: 1 }] }); j = null; }
      else if (a === 'rk') { const up = {}; (b.dataset.keys || '').split(',').filter(Boolean).forEach((k) => (up[k] = 0)); j = await post('cart/update.js', { updates: up }); }
      else j = await post('cart/change.js', { id: b.dataset.k, quantity: +b.dataset.q });
      await EK.refresh(j && j.sections);
    } catch (err) { console.warn(err); await EK.refresh(); }
    busy(false);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-ekc-close]')) { EK.close(); return; }
    const cb = e.target.closest('[data-ekh-cart], .cartbtn');
    if (cb && !onCartPage() && drawer()) { e.preventDefault(); e.stopImmediatePropagation(); EK.open(); return; }
    act(e);
  }, true);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') EK.close(); });

  /* Código de descuento y nota de regalo (página del carrito) */
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-ekc-code]'); if (!f) return; e.preventDefault();
    const code = (f.code.value || '').trim(); busy(true);
    try {
      const j = await post('cart/update.js', { discount: code });
      const ok = !code || (j.discount_codes || []).some((d) => d.code.toLowerCase() === code.toLowerCase() && d.applicable);
      await EK.refresh(j.sections);
      if (!ok) { const nf = $('[data-ekc-code]'); if (nf) { nf.code.value = code; nf.classList.add('err'); nf.code.setCustomValidity(nf.dataset.err || ''); nf.code.reportValidity(); setTimeout(() => nf.code.setCustomValidity(''), 2500); } }
    } catch (err) { console.warn(err); }
    busy(false);
  }, true);
  let nt; document.addEventListener('input', (e) => {
    const t = e.target.closest('[data-ekc-note]'); if (!t) return;
    clearTimeout(nt); nt = setTimeout(() => fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: t.value }) }), 500);
  });

  /* Cualquier "agregar" del sitio (tema, kits, arma tu kit) abre este carrito */
  let rt; document.addEventListener('cart:update', () => { clearTimeout(rt); rt = setTimeout(() => EK.refresh().then(EK.open), 120); });
  const hijack = () => $$('cart-drawer-component').forEach((d) => { if (d.dataset.ek) return; d.dataset.ek = 1; d.open = () => { clearTimeout(rt); rt = setTimeout(() => EK.refresh().then(EK.open), 120); }; d.showDialog = d.open; });
  hijack(); if (window.customElements) customElements.whenDefined('cart-drawer-component').then(hijack).catch(() => {});
  document.addEventListener('shopify:section:load', hijack);
}